import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'

const { white, neutral, starlight } = tokens.thenightly.colors.palette
const { margins, siteMetrics } = metrics.thenightly

export const StyledBanner = styled('div')({
    fontFamily: fonts.thenightly.sansSerif,
    background: neutral[100],
    p: {
        color: white,
        margin: '0 auto',
        padding: calcRem(margins.md, margins.m2l),
        fontWeight: 600,
        lineHeight: '150%',
        maxWidth: siteMetrics.mainContentWidth,
    },
    a: {
        textUnderlinePosition: 'under',
    },

    [breakpoint('sm')]: {
        a: {
            display: 'inline-block',
        },
    },

    [breakpoint('lg')]: {
        p: { padding: calcRem(margins.md, 0) },
    },
})
